import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { initSentry, sendTestLog } from '../../../shared/utils/sentry';
import App from './App';
import './index.css';

// Initialize Sentry before React renders
initSentry({
  dsn: import.meta.env.VITE_SENTRY_DSN || '',
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE || 'development',
  appName: 'giftvouchers',
  release: import.meta.env.VITE_SENTRY_RELEASE,
  enablePerformanceMonitoring: true,
  enableSessionTracking: true,
});

// Set up global error handlers
if (typeof window !== 'undefined') {
  window.addEventListener('error', (event) => {
    Sentry.captureException(event.error || new Error(event.message));
  });

  window.addEventListener('unhandledrejection', (event) => {
    Sentry.captureException(event.reason);
  });
  
  // Expose test function globally for easy testing from browser console
  // Usage: window.testSentry() or window.testSentry({ custom_field: 'value' })
  (window as any).testSentry = (data?: Record<string, any>) => {
    const eventId = sendTestLog(data);
    console.log('✅ Sentry test log sent! Event ID:', eventId);
    return eventId;
  };
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <Sentry.ErrorBoundary fallback={({ resetError }) => (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-6">
        <div className="text-center">
          <h3 className="text-lg font-medium text-gray-900 mb-2">
            Something went wrong
          </h3>
          <p className="text-sm text-gray-500 mb-4">
            We encountered an unexpected error. Please try refreshing the page.
          </p>
          <button
            onClick={resetError}
            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700"
          >
            Refresh Page
          </button>
        </div>
      </div>
    </div>
  )}>
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  </Sentry.ErrorBoundary>
);

